import React from 'react';
import "./forOrgatizations.css"
import main_block_bg from "./images/main_page_bg.svg";
import Header from "../components/Header";
import FaqItem from "./components/FaqItem";
import circles_bg from "./images/circles.svg";
import waves_bg from "./images/waves_bg.svg";
import Footer from "../components/Footer";
import advantages_image from "./images/advantages_block_image.png";

import adv_icon1 from "./images/adv_icon1.svg";
import adv_icon2 from "./images/adv_icon2.svg";
import adv_icon3 from "./images/adv_icon3.svg";
import adv_icon4 from "./images/adv_icon4.svg";

import safety_icon1 from "./images/safety_icon1.svg";
import safety_icon2 from "./images/safety_icon2.svg";
import safety_icon3 from "./images/safety_icon3.svg";
import { motion } from "framer-motion";

import green_circle_g from "./images/green_circle_gal.svg";
import works_icon1 from "./images/works_icon1.svg";
import works_icon2 from "./images/works_icon2.svg";
import works_icon3 from "./images/works_icon3.svg";
import works_icon4 from "./images/works_icon4.svg";
import left_trust from "./images/left_bg_trust_donors.svg";
import right_trust from "./images/right_bg_trust_donors.svg";
import DevelopmentButton from "../components/DevelopmentButton";

const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 } },
};

const ForOrganizations = () => {



    const faq_items = [{
        question: "Are there any platform fees?",
        answer: "Undura does not take commissions from donations. The infrastructure exists thanks to voluntary donations" +
            " supporting Undura itself. Only standard fees from the payment provider apply when processing transactions."
    }, {
        question: "Can I get a tax deduction?",
        answer: "Creating a standard template platform on Undura is free. For small projects and low-load usage, hosting on" +
            " a subdomain of undura.com is also free. If your traffic or data volume grows, or you prefer a custom" +
            " configuration, we may charge a fee that only covers hosting and maintenance costs — without any markup." +
            " You can also move the platform to your own host or domain at any time."
    }, {
        question: "How are donations transferred?",
        answer: "Donations go directly to your organization’s connected payment account.\n" +
            "Undura never holds or delays your funds"
    }, {
        question: "Is Undura only for charities?",
        answer: "No. The platform is open to charities, institutions, and verified community projects of any scale."
    },
    ]


    const pointVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, duration: 0.6, ease: "easeOut" }
        })
    };
    const fadeNumeric = {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: true },
        variants: pointVariants
    };

    const fadeUp = { initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeDown = { initial: { opacity: 0, y: -40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeLeft = { initial: { opacity: 0, x: -50 }, whileInView: { opacity: 1, x: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeRight = { initial: { opacity: 0, x: 50 }, whileInView: { opacity: 1, x: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };


    const hoverButton = {
        whileHover: {
            scale: 1.05,
            transition: { type: "spring", stiffness: 300 }
        }
    };



    const buttonAnimate = {
        initial:fadeUp.initial,
        whileInView:fadeUp.whileInView,
        viewport:fadeUp.viewport,
        transition:fadeUp.transition,
        whileHover:hoverButton.whileHover
    }

    return (
        <div className = "for_organizations">
            <motion.img src = {main_block_bg} alt = "" className = "main_block_bg" {...fadeUp}/>
            <Header/>


            <motion.div className="for_donors_main_block">
                <motion.div className="for_donors" {...fadeUp} >
                    <div className="circle"></div>
                    For Organizations
                </motion.div>
                <div className = "main_block_text">
                    <motion.div className="main_text" {...fadeLeft}>
                        Grow your mission.<br/>
                        Raise impact transparently.
                    </motion.div>
                    <motion.div className = "main_block_desc" {...fadeRight}>
                        <div className = "main_desc">
                            Undura Lite helps organizations collect donations, build trust, and focus on what truly matters — impact.
                        </div>
                        <div className="main_block_buttons">
                            <DevelopmentButton className="get_started pos_left_popup">
                                Create platform
                            </DevelopmentButton>
                            <DevelopmentButton className="explore_demo">
                                Explore demo
                            </DevelopmentButton>
                        </div>
                    </motion.div>
                </div>
            </motion.div>


            <motion.div className="platform_image_block"
                        {...fadeUp}>
                <div className = "platform_image">
                    Platform screen
                </div>
            </motion.div>



            <motion.div className="main_text"
                        {...fadeLeft}>
                How Undura Works <br/><span>for Organizations</span>
            </motion.div>
            <div
                className="about_platform_details"
            >
                {[works_icon1, works_icon2, works_icon3, works_icon4].map(
                    (icon, i) => (
                        <motion.div key={i} className="details_block" {...fadeNumeric} custom={i}>
                            <div className="icons_block">
                                <div className="details_icon">
                                    <img src={icon} alt="" />
                                </div>
                                <div className="details_number">0{i + 1}</div>
                            </div>
                            <div className="details_text">
                                <div className="details_block_name">
                                    {[
                                        "Create your project page",
                                        "Receive donations",
                                        "Track finances in real-time",
                                        "Report transparently",
                                    ][i]}
                                </div>
                                {
                                    [
                                        "Describe your mission, set your goals, and add visuals. Undura helps you present everything in a simple, engaging way for donors.",
                                        "Connect secure payment methods — no intermediaries, no platform fees. Funds go directly to your organization’s account.",
                                        "Monitor income, expenses, and balances in a live dashboard with automatic updates.",
                                        "Generate open reports and share them with donors in one click — build lasting trust in your organization.",
                                    ][i]
                                }
                            </div>
                        </motion.div>
                    )
                )}
            </div>

            <DevelopmentButton
                className="get_started"

            >
                Get started
            </DevelopmentButton>

            <motion.div
                className="main_text adv_mt_big"
                {...fadeLeft}
            >
                Key <span>Advantages</span>
            </motion.div>

            <motion.div
                className="key_advantages_full_block"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={staggerContainer}
            >
                <div className="key_advantages_details" {...fadeLeft}>
                    {[adv_icon1, adv_icon2, adv_icon3, adv_icon4].map((icon, i) => (
                        <motion.div
                            key={i}
                            className="key_advantages_details_point"
                            {...fadeNumeric}
                            custom={i}
                        >
                            <div className="key_advantages_icon_block">
                                <img src={icon} alt="" />
                                Simplified reporting tools
                            </div>
                            <div className="key_advantages_desc">
                                Use ready-made templates to create and share reports in just a few clicks.
                            </div>
                        </motion.div>
                    ))}
                </div>
                <motion.div
                    className="key_advantages_image"
                    {...fadeRight}
                >
                    <img src={advantages_image} alt="" />
                </motion.div>
            </motion.div>

            {/* Safety and Trust */}
            <motion.div
                className="main_text"
                {...fadeLeft}
            >
                Safety <span>and Trust</span>
            </motion.div>

            <motion.div
                className="safety_main_desc"
                {...fadeRight}
            >
                With Undura, we could track donations and share updates with supporters in real time.
            </motion.div>

            <motion.div
                className="technology_three_points"
            >
                {[safety_icon1, safety_icon2, safety_icon3].map((icon, i) => (
                    <motion.div key={i} className="technology_point" {...fadeNumeric} custom={i}>
                        <div className="technology_icon_block for_donors_impact">
                            <img src={icon} alt="" />
                            <div className="point_number">0{i + 1}</div>
                        </div>
                        <div className="problems_item_name">
                            {["Protected donations", "Verified donors and partners", "Reconciled with payment providers"][i]}
                        </div>
                        <div className="problems_item_desc">
                            {
                                [
                                    "All incoming payments are encrypted and processed securely — protecting your organization from fraud or data leaks.",
                                    "KYC verification is performed when needed — for large donations or unusual activity — keeping your organization secure and compliant.",
                                    "Transactions are verified against Stripe records, ensuring accurate totals and reducing accounting risk.",
                                ][i]
                            }
                        </div>
                    </motion.div>
                ))}
            </motion.div>

            <DevelopmentButton
                className="get_started safety"
            >
                Get started
            </DevelopmentButton>

            {/* FAQ */}
            <motion.div
                className="main_text"
                {...fadeLeft}
            >
                Questions you might have
            </motion.div>

            <motion.div
                className="faq_full"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={staggerContainer}
            >
                <motion.div className="faq_main" variants={{ hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6 } } }}>
                    {faq_items.map((e, idx) => <FaqItem key={idx} answer={e.answer} question={e.question} />)}
                </motion.div>
                <motion.div className="bg_circles" variants={{ hidden: { opacity: 0, scale: 0.8 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } } }}>
                    <img alt="" src={circles_bg} />
                </motion.div>
            </motion.div>


            <motion.div
                className="no_coding_block"
                {...fadeUp}
            >
                <motion.div className="no_coding_content" >
                    <img src={waves_bg} alt="" className="waves_last" />
                    <div className="powered_by_last">
                        <div className="circle"></div>
                        Powered by Undura Lite
                    </div>
                    <div className="no_coding_name">
                        Join organizations transforming donations into real impact.
                    </div>
                    <div className="no_coding_text">Create your platform</div>
                    <DevelopmentButton
                        className="start_now_button_last pos_center_popup"
                    >
                        Join now
                    </DevelopmentButton>
                </motion.div>
            </motion.div>
            <Footer mode = "lite"/>

        </div>
    );
};

export default ForOrganizations;